// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OverviewNav_wrap_b8mNQ","current":"OverviewNav_current_3aLf5"};